import React, { Component } from 'react'
import InfoBlock from '../shared/infoBlock'
import AngleBracketButton from '../shared/angleBracketButton'
import { isNarrowDesktop, Default, isTablet, Mobile } from '../../media-queries'
import Fade from 'react-reveal/Fade'
import Link from 'gatsby-link'
import Info from '../shared/info'

export default class ApplicationChoice extends Component {
  state = {
    showInfo: false,
  }

  render() {
    return (
      <div>
        <Default>
          <DefaultApplicationChoice
            {...this.props}
            {...this.state}
            toggleInfo={this.toggleInfo}
          />
        </Default>
        <Mobile>
          <MobileApplicationChoice
            {...this.props}
            {...this.state}
            toggleInfo={this.toggleInfo}
          />
        </Mobile>
      </div>
    )
  }

  toggleInfo = () => this.setState(({ showInfo }) => ({ showInfo: !showInfo }))
}

const DefaultApplicationChoice = props => (
  <div
    style={{
      display: 'flex',
    }}
  >
    <div
      style={{
        background: '#F7F7F7',
        minHeight: props.height,
        padding: isTablet()
          ? '2rem 4rem 3rem'
          : `2rem ${isNarrowDesktop() ? '5rem' : '7rem'} 2rem 5rem`,
        width: '58vw',
      }}
    >
      <InfoBlock
        title={props.title}
        bigTitle={true}
        extra={props.titleAccent}
        accentColor={'#8CBD8C'}
        text={props.text}
      />
      <Fade when={props.showInfo} collapse>
        <InfoBlock
          title={props.doubleDegreeTitle}
          text={props.doubleDegreeText}
        />
      </Fade>
    </div>
    <div
      style={{
        background: '#8CBD8C',
        minHeight: props.height,
        padding: `15vh ${isNarrowDesktop() ? '8vw' : '12.5vw'} 1rem ${
          isNarrowDesktop() ? '1rem' : '3rem'
        }`,
        width: '42vw',
      }}
    >
      <div style={{ marginBottom: '3rem' }}>
        <div
          style={{
            color: 'white',
            fontSize: 20,
            fontWeight: 700,
            marginBottom: '.5rem',
          }}
        >
          First question:
        </div>
        <div style={{ fontWeight: 600, fontSize: 14 }}>{props.stepText}</div>
      </div>
      <div>
        {props.tracks.map(({ trackName: name }) => (
          <AngleBracketButton
            key={name}
            text={name}
            onClick={() => props.setChoice(name)}
            style={{ marginBottom: '.5rem' }}
          />
        ))}
      </div>
      <div
        style={{
          margin: '3rem 0',
          fontStyle: 'italic',
          fontSize: 12,
        }}
      >
        {props.explanationDegrees}
      </div>
      <div style={{ textAlign: 'right' }}>
        <div
          style={{
            fontSize: 14,
            fontWeight: 600,
            cursor: 'pointer',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
          }}
          onClick={props.toggleInfo}
        >
          Our programmes&nbsp;&nbsp;<Info
            style={{ width: '1rem', height: '1rem' }}
            color={'#8CBD8C'}
          />
        </div>
      </div>
    </div>
  </div>
)

const MobileApplicationChoice = props => (
  <div
    style={{
      background: '#8CBD8C',
    }}
  >
    <InfoBlock
      title={props.title}
      extra={props.titleAccent}
      text={props.text}
      style={{ padding: '1rem 2rem 1rem' }}
    />
    <div style={{ margin: '0 3rem 0', paddingBottom: '1rem' }}>
      <div
        style={{
          color: 'white',
          fontSize: 20,
          fontWeight: 700,
          marginBottom: '.5rem',
        }}
      >
        First question:
      </div>
      <div style={{ fontWeight: 600, fontSize: 14 }}>{props.stepText}</div>
    </div>
    <div style={{ margin: '1rem 2rem' }}>
      {props.tracks.map(({ trackName: name }) => (
        <AngleBracketButton
          key={name}
          text={name}
          onClick={() => props.setChoice(name)}
          style={{ marginBottom: '.5rem' }}
        />
      ))}
    </div>
    <div
      style={{
        margin: '1rem 3rem',
        fontStyle: 'italic',
        fontSize: '12px',
      }}
    >
      {props.explanationDegrees}
    </div>
    <div
      style={{
        textAlign: 'right',
        marginRight: '3rem',
        paddingBottom: '3rem',
      }}
    >
      <div
        style={{
          fontSize: 14,
          fontWeight: 600,
          cursor: 'pointer',
        }}
      >
        <Link to={'/programme#double-degree'}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
            }}
          >
            Our programme&nbsp;&nbsp;<Info
              style={{ width: '1rem', height: '1rem' }}
              color={'#8CBD8C'}
            />
          </div>
        </Link>
      </div>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/application/applicationChoice.js